import React from 'react';
import { useMatch } from 'react-router-dom';
import StartNewQuery from '@/components/StartNewQuery';
import { QuerySteps } from '@/containers/StepsSidebar/QuerySteps';
import { AvailableButtons } from '@/components/StartNewQuery/types';
import { useSelector } from 'react-redux';
import { getLayers } from '@/store-selectors';

export type StepsSidebarProps = {
  sidebarOpen: boolean;
  availableButtons: AvailableButtons[];
};

export const StepsSidebar: React.FC<StepsSidebarProps> = ({
  availableButtons,
  sidebarOpen,
}) => {
  const localSteps = useSelector(getLayers);
  const isNewQueryPrivate = !!useMatch('/datasources/:datasourceId');
  const isNewQueryPublic = !!useMatch('/publicdatasets/:datasourceId');
  const [transitionsOn, setTransitionsOn] = React.useState(true);
  const [lastAddStepButtonsOpened, setLastAddStepButtonsOpened] =
    React.useState(null);

  const isNewQuery = isNewQueryPrivate || isNewQueryPublic;
  const hasSteps = localSteps.all.length > 0;
  const showSteps = hasSteps || !isNewQuery;

  React.useEffect(() => {
    setTransitionsOn(false);
    setLastAddStepButtonsOpened(null);

    const timeoutId = setTimeout(() => setTransitionsOn(true), 50);

    return () => clearTimeout(timeoutId);
  }, [isNewQuery]);

  return showSteps ? (
    <QuerySteps
      transitionsOn={transitionsOn}
      lastAddStepButtonsOpened={lastAddStepButtonsOpened}
      setAddStepButtonsOpened={setLastAddStepButtonsOpened}
    />
  ) : (
    <StartNewQuery
      sidebarOpen={sidebarOpen}
      availableButtons={availableButtons}
    />
  );
};

export default StepsSidebar;
